import React from "react";

function PaymentConfirmation() {
  return <div>PaymentConfirmation</div>;
}

export default PaymentConfirmation;
